export default "__VITE_ASSET__CUTaOPOZ__"